import { i18n } from '../../i18n/i18n.js'

export class LoadingState {
  constructor(container) {
    this.container = container || document.body
    this.element = null
    this.retryCallback = null
  }

  show(message) {
    this.hide()

    this.element = document.createElement('div')
    this.element.className = 'loading-state-overlay'
    this.element.innerHTML = `
      <div class="loading-state-content">
        <div class="loading-spinner"></div>
        <p class="loading-message">${message || i18n.t('common.loading')}</p>
      </div>
    `

    this.container.appendChild(this.element)
  }

  showError(message, onRetry) {
    this.hide()

    this.element = document.createElement('div')
    this.element.className = 'loading-state-overlay error'
    this.element.innerHTML = `
      <div class="loading-state-content">
        <div class="error-icon">!</div>
        <p class="error-message">${message || i18n.t('errors.dataLoadFailed')}</p>
        ${onRetry ? `<button class="retry-btn">${i18n.t('common.retry')}</button>` : ''}
      </div>
    `

    if (onRetry) {
      this.retryCallback = onRetry
      this.element.querySelector('.retry-btn').addEventListener('click', onRetry)
    }

    this.container.appendChild(this.element)
  }

  hide() {
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element)
    }
    this.element = null
    this.retryCallback = null
  }
}
